import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faCopy,
  faCircleCheck,
} from "@fortawesome/free-solid-svg-icons";
import {
  faLinkedin,
  faInstagram,
  faGithub,
  faMedium,
  faStackOverflow,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";

import BgContact from "../assets/bg-contact.svg";
import Footer from "../components/footer";

const ContactPage = () => {
  const [buttonText, setButtonText] = useState(`Copy email to clipboard`);
  const [copied, setCopied] = useState(false);

  const copyToClipBoardText = async () => {
    const email = "mukkadeepak@gmail.com";
    await navigator.clipboard.writeText(email);
    setCopied(true);
    setButtonText("Copied sucessfully");
    setTimeout(() => {
      setCopied(false);
      setButtonText("Copy email to clipboard");
    }, 2000);
  };

  return (
    <>
      <div id="contact">
        <h2 className="md:text-5xl text-center font-bold text-white text-4xl pt-10">
          ✌️ Connect with me
        </h2>
        <section className="mt-20 mx-auto max-w-screen-xl h-auto pb-10 px-4 sm:px-8">
          <img
            src={BgContact}
            height="350"
            width="350"
            className="m-auto w-1/2 mt-10 mb-10 lg:w-1/4"
            alt="bgcontact"
          />
          <div className="flex flex-col text-white text-center text-lg m-4 justify-center items-center">
            <p className="text-center text-semibold text-base md:text-xl w-3/4">
              My inbox is always open. Whether you have a question or just want
              to say hello, I'll try my best to get back to you! Feel free to
              mail me about any relevant job updates.
            </p>
            <div className="flex flex-col justify-center items-center sm:flex-row text-sm xs:text-base">
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=mukkadeepak@gmail.com"
                rel="noreferrer"
                target="_blank"
                className="px-3 py-2 w-auto  bg-[#4A6CF7] hover:bg-[#3468d0cc] text-white text-center rounded-md shadow-md m-5 md:m-10"
              >
                <FontAwesomeIcon icon={faEnvelope} /> Mail me
              </a>

              <button
                rel="noreferrer"
                target="_blank"
                className={`px-3 py-2 w-auto focus:z-10 focus:ring-4 focus:ring-gray-700 hover:bg-gray-600 border-gray-600 text-gray-200 bg-gray-700 text-center rounded-md shadow-md`}
                onClick={copyToClipBoardText}
              >
                {copied ? (
                  <FontAwesomeIcon icon={faCircleCheck} />
                ) : (
                  <FontAwesomeIcon icon={faCopy} />
                )}{" "}
                {buttonText}
              </button>
            </div>
          </div>

          <div className="text-2xl md:text-4xl text-white flex justify-center items-center">
            <a
              href="https://www.linkedin.com/in/mukka-deepak-347b7119a/"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon
                icon={faLinkedin}
                title="Linkedin"
                className="transition ease-out delay-150  hover:-translate-y-1 hover:scale-110 cursor-pointer m-4"
              />
            </a>
            <a
              href="https://github.com/Deepakmukka1"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon
                icon={faGithub}
                title="Github"
                className="transition ease-out delay-150  hover:-translate-y-1 hover:scale-110 cursor-pointer m-4"
              />
            </a>
            <a
              href="https://mukkadeepak.medium.com/"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon
                icon={faMedium}
                title="Medium"
                className="transition ease-out delay-150  hover:-translate-y-1 hover:scale-110 cursor-pointer m-4"
              />
            </a>
            <a
              href="https://www.instagram.com/deepakmukka/"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon
                icon={faInstagram}
                title="Instagram"
                className="transition ease-out delay-150  hover:-translate-y-1 hover:scale-110 cursor-pointer m-4"
              />
            </a>
            <a
              href="https://stackoverflow.com/users/12736321/deepak-mukka"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon
                icon={faStackOverflow}
                title="Stackoverflow"
                className="transition ease-out delay-150  hover:-translate-y-1 hover:scale-110 cursor-pointer m-4"
              />
            </a>

            <a
              href="https://twitter.com/DeepakMukka"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon
                icon={faTwitter}
                title="Twitter"
                className="transition ease-out delay-150  hover:-translate-y-1 hover:scale-110 cursor-pointer m-4"
              />
            </a>
          </div>

          <div className="mt-10 text-xl text-white flex justify-center items-center">
            <Footer />
          </div>
        </section>
      </div>
    </>
  );
};

export default ContactPage;